import React from 'react';
import ButtonCancelForm from '../../../components/buttons/ButtonCancelForm';
import ButtonSaveForm from '../../../components/buttons/ButtonSaveForm';
import SalesInvoiceForm from './forms/SalesInvoiceForm';
import { Society } from '../../../app/models/Society';
import { Client } from '../../../app/models/Client';


interface Props {
    fetching?: boolean;
    action: () => void;
    cancel: () => void;
    salesInvoice: any;
    setSalesInvoice: (salesInvoice: any) => void;
    errorFields?: any;
    updated: boolean;
    disabled: boolean;
    societies: Society[];
    clients: Client[];
    deliveries?: any[];
    loadingClient?: boolean;
    loadingDeliveries?: boolean;
    onSocietyChange?: (societyId: number | string) => void;
    onClientChange?: (clientId: number | string) => void;
}

const SalesInvoiceFormContainer = ({
    fetching,
    action,
    cancel,
    salesInvoice,
    setSalesInvoice,
    updated = false,
    disabled = false,
    errorFields = null,
    societies,
    clients,
    deliveries = [],
    loadingClient,
    loadingDeliveries,
    onSocietyChange,
    onClientChange
}: Props) => {
    return (
        <>
            <div className="row">
                <div className="col-12">
                    <SalesInvoiceForm
                        salesInvoice={salesInvoice}
                        setSalesInvoice={setSalesInvoice}
                        societies={societies}
                        clients={clients}
                        deliveries={deliveries}
                        errorFields={errorFields}
                        is_edit={updated}
                        loadingClients={loadingClient}
                        loadingDeliveries={loadingDeliveries}
                        onSocietyChange={onSocietyChange}
                        onClientChange={onClientChange}
                    />
                </div>
            </div>
            <hr />
            <div className="row justify-content-end">
                <div className="col-auto">
                    <ButtonCancelForm callbackCancel={cancel} locked={fetching} />
                </div>
                <div className="col-auto">
                    <ButtonSaveForm callbackSave={action} locked={fetching} />
                </div>
            </div>
        </>
    );
};

export default SalesInvoiceFormContainer;
